import React from "react";

import styles from "./styles.module.scss";

const InfoLabel = ({ children }) => (
  <div className={styles.label}>{children}</div>
);

export default InfoLabel;
